/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_TitleInputs */

const en_admin_users_title = /** @type {(inputs: Admin_Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

const zh_admin_users_title = /** @type {(inputs: Admin_Users_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户管理`)
};

/**
* | output |
* | --- |
* | "Users" |
*
* @param {Admin_Users_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_title = /** @type {((inputs?: Admin_Users_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_title(inputs)
	return zh_admin_users_title(inputs)
});
export { admin_users_title as "admin.users.title" }